import { Franchise } from '@/types';
import { Typography } from 'antd';

interface Props {
  franchisor: Partial<Franchise>;
}

export default function FranchisorContactAdminSection({ franchisor }: Props) {
  return (
    <div className="details-section-column">
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">Email</Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.email ? franchisor.email : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">Phone</Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.phone ? franchisor.phone : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Corporate Website
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.corporateWebsite ? franchisor.corporateWebsite : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Corporate Address
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.corporateAddress ? franchisor.corporateAddress : '-'}
        </Typography.Text>
      </div>
    </div>
  );
}
